export default __webpack_public_path__ + "static/media/customwebsitedesigndevelopment.fbd4084f.gif";